import React, { useEffect, useState } from 'react';
import { Radio } from 'lucide-react';
import { API } from '../../api';

const money = (n) => `$${Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—');
const TONE = { active: 'text-emerald-400 border-emerald-500/40', past_due: 'text-heart border-heart/40', canceled: 'text-cream/45 border-cream/20' };

export default function Subscribers({ plans }) {
  const [data, setData] = useState(null);
  useEffect(() => { API.studioSubscriptions().then(setData).catch(() => setData({ subscriptions: [], mrr: 0, active: 0 })); }, []);
  if (!data) return null;
  return (
    <div data-testid="studio-subscribers">
      <div className="grid sm:grid-cols-3 gap-4 mb-8">
        {[['Active plans', data.active], ['Monthly value', money(data.mrr)], ['All time', data.subscriptions.length]].map(([l, v]) => (
          <div key={l} className="panel rounded-2xl p-5"><p className="eyebrow text-[9px]">{l}</p><p className="font-display text-3xl text-cream mt-2" data-testid={`subs-stat-${l.toLowerCase().replace(/\s/g, '-')}`}>{v}</p></div>
        ))}
      </div>
      {!data.subscriptions.length ? (
        <p className="text-sm text-cream/50 rounded-2xl border hairline p-6">No subscribers yet. Plans are sold on the <a href="/pricing" className="text-gold hover:underline">pricing page</a> and from the customer dashboard.</p>
      ) : (
        <div className="panel rounded-3xl overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] tracking-widest uppercase text-cream/45 border-b hairline">
              <th className="px-5 py-3">Business</th><th className="px-5 py-3">Plan</th><th className="px-5 py-3">Billing</th><th className="px-5 py-3">Renews</th><th className="px-5 py-3">Status</th>
            </tr></thead>
            <tbody>
              {data.subscriptions.map((s) => (
                <tr key={s.id} className="border-b hairline last:border-0" data-testid={`sub-row-${s.id}`}>
                  <td className="px-5 py-3"><p className="text-cream">{s.business}</p><p className="text-xs text-cream/45">{s.owner_email}</p></td>
                  <td className="px-5 py-3 text-cream/80"><span className="flex items-center gap-2"><Radio size={13} className="text-gold" /> {plans?.tiers?.[s.tier]?.name || s.tier}</span></td>
                  <td className="px-5 py-3 text-cream/80">{money(s.per_term)} {plans?.terms?.[s.term]?.name?.toLowerCase() || s.term}</td>
                  <td className="px-5 py-3 text-cream/80">{fmtDate(s.current_period_end)}</td>
                  <td className="px-5 py-3"><span className={`text-[10px] tracking-widest uppercase border rounded-full px-2 py-0.5 ${TONE[s.status] || TONE.canceled}`}>{s.cancel_at_period_end ? 'ends at term' : s.status.replace('_', ' ')}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
